module.exports = __webpack_public_path__ + "img/5c0ec94.png";